<template>
  <div>
    <div class="md-layout">
      <!-- FIRSTNAME -->
      <div class="md-layout-item md-size-50 md-small-size-100">
        <md-field
          :class="[
            { 'md-valid': !errors.has('firstName') && touched.firstName },
            { 'md-form-group': true },
            { 'md-error': errors.has('firstName') }
          ]"
        >
          <md-icon>person_outline</md-icon>
          <label>First Name</label>
          <md-input v-validate="'required'" v-model="firstName" style="width: inherit" type="text" name="firstName" />
          <!-- data-vv-name="firstName" -->
          <slide-y-down-transition>
            <md-icon v-show="errors.has('firstName')" style="padding: 0" class="alert">close</md-icon>
          </slide-y-down-transition>
          <slide-y-down-transition>
            <md-icon v-show="!errors.has('firstName') && touched.firstName" class="success">done</md-icon>
          </slide-y-down-transition>
        </md-field>
      </div>

      <!-- LASTNAME -->
      <div class="md-layout-item md-size-50 md-small-size-100">
        <md-field
          :class="[
            { 'md-valid': !errors.has('lastName') && touched.lastName },
            { 'md-form-group': true },
            { 'md-error': errors.has('lastName') }
          ]"
        >
          <md-icon>person</md-icon>
          <label>Last Name</label>
          <md-input
            v-validate="'required'"
            v-model="lastName"
            style="width: inherit"
            data-vv-name="lastName"
            type="text"
            name="lastName"
          />

          <slide-y-down-transition>
            <md-icon v-show="errors.has('lastName')" style="padding: 0" class="alert">close</md-icon>
          </slide-y-down-transition>
          <slide-y-down-transition>
            <md-icon v-show="!errors.has('lastName') && touched.lastName" class="success">done</md-icon>
          </slide-y-down-transition>
        </md-field>
      </div>
    </div>

    <div class="md-layout">
      <!-- GENDER -->
      <div class="md-layout-item md-size-30 md-small-size-100">
        <md-field
          :class="[
            { 'md-valid': !errors.has('gender') && touched.gender },
            { 'md-form-group': true },
            { 'md-error': errors.has('gender') }
          ]"
        >
          <md-icon style="margin-right: 0; padding-right: 10px">man_4</md-icon>
          <div style="margin-left: 15px">
            <md-radio v-model="gender" value="Male" style="padding-right: 30px"
              ><span style="margin-top: -9px; position: absolute; font-size: 14px">Male</span></md-radio
            >
            <md-radio v-model="gender" value="Female"
              ><span style="margin-top: -9px; position: absolute; font-size: 14px">Female</span></md-radio
            >
          </div>

          <slide-y-down-transition>
            <md-icon v-show="errors.has('gender')" style="padding: 0" class="alert">close</md-icon>
          </slide-y-down-transition>
          <slide-y-down-transition>
            <md-icon v-show="!errors.has('gender') && touched.gender" class="success">done</md-icon>
          </slide-y-down-transition>
        </md-field>
      </div>
      <!-- EMAIL -->
      <div class="md-layout-item md-size-70 md-small-size-100">
        <md-field
          :class="[
            { 'md-valid': !errors.has('email') && touched.email },
            { 'md-form-group': true },
            { 'md-error': errors.has('email') }
          ]"
          style="margin-top: 25px"
        >
          <md-icon>mail_outline</md-icon>
          <label>Email</label>
          <md-input
            v-validate="{ required: true, email: true }"
            v-model="email"
            style="width: inherit"
            data-vv-name="email"
            type="email"
            name="email"
          />

          <slide-y-down-transition>
            <md-icon v-show="errors.has('email')" style="padding: 0" class="alert">close</md-icon>
          </slide-y-down-transition>
          <slide-y-down-transition>
            <md-icon v-show="!errors.has('email') && touched.email" class="success">done</md-icon>
          </slide-y-down-transition>
        </md-field>
      </div>
    </div>

    <div class="md-layout">
      <!-- CELLPHONE -->
      <div class="md-layout-item md-size-100 md-small-size-100">
        <!--style="margin-top: 30px"-->
        <md-field
          :class="[
            { 'md-valid': !errors.has('cellPhone') && touched.cellPhone },
            { 'md-form-group': true },
            { 'md-error': errors.has('cellPhone') }
          ]"
          style="margin-top: 25px"
        >
          <md-icon>smartphone</md-icon>
          <label>Cell Phone</label>
          <md-input
            v-mask="'(999) 999 - 9999'"
            v-validate="{ required: true, min: 10 }"
            v-model="cellPhone"
            data-vv-name="cellPhone"
            type="tel"
            name="cellPhone"
            style="font-size: xx-large"
          />
          <slide-y-down-transition>
            <md-icon v-show="errors.has('cellPhone')" style="padding: 0" class="alert">close</md-icon>
          </slide-y-down-transition>
          <slide-y-down-transition>
            <md-icon v-show="!errors.has('cellPhone') && touched.cellPhone" class="success">done</md-icon>
          </slide-y-down-transition>
        </md-field>
      </div>
    </div>

    <div class="md-layout">
      <!-- ADDRESS-L1 -->
      <div class="md-layout-item md-size-50 md-small-size-100">
        <md-field
          :class="[
            { 'md-valid': !errors.has('address1') && touched.address1 },
            { 'md-form-group': true },
            { 'md-error': errors.has('address1') }
          ]"
        >
          <md-icon>location_on</md-icon>
          <label>Address Line 1</label>
          <md-input
            v-validate="'required'"
            v-model="address1"
            style="width: inherit"
            data-vv-name="address1"
            type="text"
            name="address1"
          />
          <slide-y-down-transition>
            <md-icon v-show="errors.has('address1')" style="padding: 0" class="alert">close</md-icon>
          </slide-y-down-transition>
          <slide-y-down-transition>
            <md-icon v-show="!errors.has('address1') && touched.address1" class="success">done</md-icon>
          </slide-y-down-transition>
        </md-field>
      </div>

      <!-- ADDRESS-L2 -->
      <div class="md-layout-item md-size-150 md-small-size-100">
        <md-field
          :class="[
            { 'md-valid': !errors.has('address2') && touched.address2 },
            { 'md-form-group': true },
            { 'md-error': errors.has('address2') }
          ]"
        >
          <md-icon>location_on</md-icon>
          <label>Address Line 2</label>
          <md-input v-model="address2" style="width: inherit" data-vv-name="address2" type="text" name="address2" />
          <slide-y-down-transition>
            <md-icon v-show="errors.has('address2')" style="padding: 0" class="alert">close</md-icon>
          </slide-y-down-transition>
          <slide-y-down-transition>
            <md-icon v-show="!errors.has('address2') && touched.address2" class="success">done</md-icon>
          </slide-y-down-transition>
        </md-field>
      </div>
    </div>

    <div class="md-layout">
      <!-- CITY -->
      <div class="md-layout-item md-size-100">
        <md-field
          :class="[
            { 'md-valid': !errors.has('city') && touched.city },
            { 'md-form-group': true },
            { 'md-error': errors.has('city') }
          ]"
        >
          <md-icon>location_city</md-icon>
          <label>City</label>
          <md-input
            v-validate="'required'"
            v-model="city"
            style="width: inherit"
            data-vv-name="city"
            type="text"
            name="city"
          />
          <slide-y-down-transition>
            <md-icon v-show="errors.has('city')" style="padding: 0" class="alert">close</md-icon>
          </slide-y-down-transition>
          <slide-y-down-transition>
            <md-icon v-show="!errors.has('city') && touched.city" class="success">done</md-icon>
          </slide-y-down-transition>
        </md-field>
      </div>
    </div>

    <div class="md-layout">
      <!-- STATE -->
      <div class="md-layout-item md-size-25">
        <md-field
          :class="[
            { 'md-valid': !errors.has('State') && touched.state },
            { 'md-form-group': true },
            { 'md-error': errors.has('State') }
          ]"
          @click.native="stateClearFilter"
          @keydown.native="stateFind($event)"
        >
          <md-icon>outlined_flag</md-icon>
          <label>State</label>
          <md-select
            v-validate="'required'"
            id="state-select"
            ref="stateInput"
            v-model="state"
            style="margin-left: 20px"
            data-vv-name="State"
            type="text"
            name="State"
            md-dense
            @keydown.native="stateFind($event)"
          >
            <md-option
              v-for="(state, index) in states"
              :key="state.LookupId"
              :id="state.LookupId"
              :value="state.LookupId"
              >{{ state.DisplayValue }}</md-option
            >
          </md-select>
          <slide-y-down-transition>
            <md-icon v-show="errors.has('State')" style="padding: 0" class="alert">close</md-icon>
          </slide-y-down-transition>
        </md-field>
      </div>

      <!-- COUNTRY -->
      <div class="md-layout-item md-size-50">
        <md-field
          v-if="countrySwitch"
          :class="[{ 'md-valid': touched.country }, { 'md-form-group': true }, { 'md-error': errors.has('country') }]"
          @click.native="countryClearFilter"
          @keydown.native="countryFind($event)"
        >
          <md-icon>outlined_flag</md-icon>
          <label>Country</label>
          <md-select
            v-validate="'required'"
            id="country-select"
            ref="countryInput"
            v-model="country"
            type="text"
            name="country"
            md-dense
          >
            <md-option
              v-for="(country, index) in countries"
              :key="country.LookupId"
              :value="country.LookupId"
              :id="country"
            >
              {{ country.DisplayValue }}
            </md-option>
          </md-select>
          <slide-y-down-transition>
            <md-icon v-show="errors.has('country')" style="padding: 0" class="alert">close</md-icon>
          </slide-y-down-transition>
        </md-field>
      </div>

      <!-- ZIPCODE -->
      <div class="md-layout-item md-size-25">
        <md-field
          :class="[
            { 'md-valid': !errors.has('zip') && touched.zip },
            { 'md-form-group': false },
            { 'md-error': errors.has('zip') }
          ]"
        >
          <md-icon>location_on</md-icon>
          <label class="spaced-phone-label">Zip-Code</label>
          <md-input
            v-validate="'required'"
            ref="zipCodeInput"
            v-model="zip"
            style="width: inherit"
            data-vv-name="zip"
            type="text"
            name="zip"
          />
          <slide-y-down-transition>
            <md-icon v-show="errors.has('zip')" style="padding: 0" class="alert">close</md-icon>
          </slide-y-down-transition>
          <slide-y-down-transition>
            <md-icon v-show="!errors.has('zip') && touched.zip" class="success">done</md-icon>
          </slide-y-down-transition>
        </md-field>
      </div>
    </div>
  </div>
</template>
<script>
import { IconCheckbox } from "@/components"
import { SlideYDownTransition } from "vue2-transitions"
import $ from "jquery"
import { mapGetters, mapActions } from "vuex"
export default {
  components: {
    IconCheckbox,
    SlideYDownTransition
  },
  props: {
    isEdit: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      countrySwitch: true,
      firstName: "",
      lastName: "",
      email: "",
      gender: "",
      cellPhone: "",
      address1: "",
      address2: "",
      city: "",
      state: "",
      zip: "",
      country: "",

      touched: {
        firstName: false,
        lastName: false,
        email: false,
        gender: false,
        cellPhone: false,
        address1: false,
        address2: false,
        city: false,
        state: false,
        zip: false,
        country: false
      },
      stateFilterKeys: "",
      countryFilterKeys: "",
      states: [],
      countries: []
    }
  },
  mounted() {
    this.defineLookups()
  },
  computed: {
    ...mapGetters(["adminReg"])
  },
  watch: {
    firstName() {
      this.touched.firstName = true
    },
    lastName() {
      this.touched.lastName = true
    },
    email() {
      this.touched.email = true
    },
    gender() {
      this.touched.gender = true
    },

    cellPhone() {
      this.touched.cellPhone = true
    },

    address1() {
      this.touched.address1 = true
    },
    address2() {
      this.touched.address2 = true
    },
    city() {
      this.touched.city = true
    },
    state() {
      this.touched.state = true
    },
    zip() {
      this.touched.zip = true
    },
    country() {
      this.touched.country = true
    }
  },
  methods: {
    ...mapActions(["listLookupsByMasterName"]),
    fetchLookupByName(name) {
      return this.listLookupsByMasterName(name)
    },
    async defineLookups() {
      try {
        const [states, countries] = await Promise.all([
          this.fetchLookupByName("States"),
          this.fetchLookupByName("CountryCodes")
        ])
        this.states = states
        this.countries = countries

        if (this.isEdit) {

          this.fillValues()
        }
      } catch (error) {
        console.error("Error fetching lookups:", error)
      }
    },
    defineGender(gender) {
      if (!gender) return ""
      switch (gender.toLowerCase()) {
        case "male":
          return "Male"
        case "female":
          return "Female"
        default:
          return ""
      }
    },
    stringToLookup(lookupList, input) {
      const num = parseInt(input, 10);
      const search = (input || '').toString().toLowerCase();

      return lookupList.find(item =>
        item.LookupId === num ||
        (item.Name || '').toLowerCase() === search ||
        (item.Value || '').toLowerCase() === search
      ).LookupId || null;
    },
    fillValues() {
      this.firstName = this.adminReg.person.firstName
      this.lastName = this.adminReg.person.lastName
      this.email = this.adminReg.person.email
      this.gender = this.defineGender(this.adminReg.person.gender)
      this.cellPhone = this.adminReg.person.cellPhone
      this.address1 = this.adminReg.address.address1
      this.address2 = this.adminReg.address.address2
      this.city = this.adminReg.address.city
      this.state = this.stringToLookup(this.states, this.adminReg.address.state)
      this.zip = this.adminReg.address.zipCode
      this.country = this.stringToLookup(this.countries, this.adminReg.address.country)
    },
    storeValues() {
      this.adminReg.person.firstName = this.firstName
      this.adminReg.person.lastName = this.lastName
      this.adminReg.person.email = this.email
      this.adminReg.person.gender = this.gender
      this.adminReg.person.cellPhone = this.cellPhone
      this.adminReg.address.address1 = this.address1
      this.adminReg.address.address2 = this.address2
      this.adminReg.address.city = this.city
      this.adminReg.address.state = this.state
      this.adminReg.address.zipCode = this.zip
      this.adminReg.address.country = this.country
    },
    getError(fieldName) {
      return this.errors.first(fieldName)
    },
    validate() {
      this.storeValues()
      return this.$validator.validateAll().then((res) => {
        this.$emit("on-validated", res)
        return res
      })
    },
    stateFind(event) {
      if (event.key === "Escape") {
        this.stateFilterKeys = ""
      }
      if (event.key === "Enter") {
        // this.reRenderState()
        this.$refs.zipCodeInput.$el.focus()
      }
      if (event.key.length > 1) return
      if (this.stateFilterKeys.length < 2) {
        this.stateFilterKeys += event.key.toUpperCase()
      } else {
        this.stateFilterKeys = event.key.toUpperCase()
      }
      let foundState = this.states.find((state) => {
        return state.startsWith(this.stateFilterKeys)
      })
      if (!foundState) {
        this.stateFilterKeys = ""
        return
      }
      this.state = foundState
      let value = this.states.indexOf(foundState) * 43
      let stateID = $("#" + foundState + "-state")
      let scrollParent = $(stateID).parent().parent()
      $(scrollParent).scrollTop(value)
    },
    countryFind(event) {
      if (event.key === "Enter") {
        this.reRenderCountry()
        this.reRenderBizphone(true)
      }
      if (event.key === "Escape") {
        this.countryFilterKeys = ""
      }
      if (event.key === "Backspace") {
        this.countryFilterKeys = this.countryFilterKeys.substring(0, this.countryFilterKeys.length - 1)
      }
      if (event.key.length > 1) return

      this.countryFilterKeys += event.key

      let foundCountry = this.countries.find((country) => {
        return country.DisplayValue.toLowerCase().startsWith(this.countryFilterKeys.toLowerCase())
      })

      this.country = foundCountry
      let value = this.countries.indexOf(foundCountry) * 43
      let countryID = $("#" + foundCountry)
      let scrollParent = $(countryID).parent().parent()

      $(scrollParent).scrollTop(value)
    },
    stateClearFilter() {
      this.stateFilterKeys = ""
    },
    countryClearFilter() {
      this.countryFilterKeys = ""
    },
    focus(type) {
      let el = $("#" + type + "-select")
      el.focus()
    }
  }
}
</script>

<style lang="scss" scoped>
.lbl1 {
  font-size: 0.6rem;
  color: rgba(0, 0, 0, 0.6);
}

.md-select menu .md-list-item .md-list-item-content {
  min-height: 25px;
}

.md-card-wizard .tab-content {
  padding: 20px, 0px;
}
</style>

<style lang="scss">
#no-side-padding {
  margin-left: 0 !important;
  margin-right: 0 !important;
}

.modify-checkbox {
  .md-checkbox-label {
    padding-left: 5px;
  }
}
</style>
